export function appendToStorage(name, item) {
  let list = JSON.parse(localStorage.getItem(name)) || [];
  list.push(item);
  localStorage.setItem(name, JSON.stringify(list));
}

export function removeFromStorage(name, item) {
  let list = JSON.parse(localStorage.getItem(name));
  _.remove(list, item);
  localStorage.setItem(name, JSON.stringify(list));
}

export function isInStorage(name, item) {
  let list = JSON.parse(localStorage.getItem(name));
  return _.includes(list, item);
}

export function getStoredList(name) {
  return JSON.parse(localStorage.getItem(name)) || [];
}

export function restartGame() {
  if (confirm("Do you want to reset the whole game?\n NOTE: THIS WILL RESET ALL UNLOCKED IMAGES")) {
    localStorage.clear();
    setTimeout(() => location.reload(), 1300);
  }
}